import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ReadFilterResponse } from '@models/music.model';
import { MusicService } from '@services/music.service';
import { map } from 'rxjs';


export const musicResolver: ResolveFn<ReadFilterResponse> = (route, state) => {
	const musicSvc = inject(MusicService);
    return musicSvc.readFilteredSongs({ page: 1, number: 300000 }).pipe(
        map(res => res)
    )
};